'use strict';

(function () {
  'use strict';

  angular.module('msOnboarding').controller('requestResetPasswordCtrl', RequestResetPasswordCtrl);
  RequestResetPasswordCtrl.$inject = ['$rootScope', 'authenticationSvc', '$stateParams', 'domainSvc'];

  function RequestResetPasswordCtrl($rootScope, authenticationSvc, $stateParams, domainSvc) {
    var vm = this;
    vm.loginUrl = domainSvc.getAppDomain() + '/login';
    vm.signUpUrl = domainSvc.getAppDomain() + '/signup';
    vm.translatePrefix = $stateParams.locked === 'true' ? 'locked' : 'reset';
    vm.isMobileWebView = $stateParams.isMobileWebView === 'true' || $stateParams.isMobileWebView === true;
    vm.mobilePlatform = $stateParams.mobilePlatform === 'android' ? 'android' : 'ios';

    activate();

    vm.sendPasswordResetEmail = function (email) {
      vm.pending = true;
      authenticationSvc.requestPasswordResetEmail(email).then(function () {
        vm.sent = true;
        vm.invalid = false;
      }, function () {
        vm.invalid = true;
      }).finally(function () {
        return vm.pending = false;
      });
    };

    /////////

    function activate() {
      _initMobileWebView();
    }

    function _initMobileWebView() {
      if (!vm.isMobileWebView) {
        return;
      }
      // Set signUpUrl with webview query params
      vm.signUpUrl = domainSvc.getAppDomain() + '/signup' + '?isMobileWebView&mobilePlatform=' + vm.mobilePlatform;
    }
  }
})();